import React from 'react';

//
export default class PaymentContent extends React.Component {
  render() {
    const {
      intl: { messages },
    } = this.props;

    return <p>SEPA Payment Content</p>;
  }
}
PaymentContent.defaultProps = {
  employee: false,
};
